/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Show_Or_Hide_TimelineInputs */

const en_show_or_hide_timeline = /** @type {(inputs: Show_Or_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show or hide timeline`)
};

const fr_show_or_hide_timeline = /** @type {(inputs: Show_Or_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher ou masquer la ligne de temps`)
};

const de_show_or_hide_timeline = /** @type {(inputs: Show_Or_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitleiste ein- oder ausblenden`)
};

const it_show_or_hide_timeline = /** @type {(inputs: Show_Or_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra o nascondi la cronologia`)
};

const ru_show_or_hide_timeline = /** @type {(inputs: Show_Or_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать или скрыть временную шкалу`)
};

const es_show_or_hide_timeline = /** @type {(inputs: Show_Or_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar u ocultar la línea de tiempo`)
};

const zh_cn2_show_or_hide_timeline = /** @type {(inputs: Show_Or_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示或隐藏时间线`)
};

const ja_show_or_hide_timeline = /** @type {(inputs: Show_Or_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムラインを表示または非表示にする`)
};

const hi_show_or_hide_timeline = /** @type {(inputs: Show_Or_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमलाइन दिखाएं या छिपाएं`)
};

const pt_pt2_show_or_hide_timeline = /** @type {(inputs: Show_Or_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar ou ocultar a linha do tempo`)
};

/**
* | output |
* | --- |
* | "Show or hide timeline" |
*
* @param {Show_Or_Hide_TimelineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const show_or_hide_timeline = /** @type {((inputs?: Show_Or_Hide_TimelineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_Or_Hide_TimelineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_show_or_hide_timeline(inputs)
	if (locale === "de") return de_show_or_hide_timeline(inputs)
	if (locale === "it") return it_show_or_hide_timeline(inputs)
	if (locale === "ru") return ru_show_or_hide_timeline(inputs)
	if (locale === "es") return es_show_or_hide_timeline(inputs)
	if (locale === "zh-CN") return zh_cn2_show_or_hide_timeline(inputs)
	if (locale === "ja") return ja_show_or_hide_timeline(inputs)
	if (locale === "hi") return hi_show_or_hide_timeline(inputs)
	if (locale === "pt-PT") return pt_pt2_show_or_hide_timeline(inputs)
	return en_show_or_hide_timeline(inputs)
});